<div class="container-fluid mt-3">
  <form [formGroup]="highlightForm">

    <h2 class="text-center mb-4">Add Counselling Highlight</h2>

    <!-- ░░ CAREGIVERS TABLE ░░ -->
    <mat-card class="p-3 mb-4" formGroupName="caregiver">
      <h4 class="mb-3">Caregivers</h4>

      <div class="row">

        <mat-form-field class="col-md-3" appearance="outline">
          <mat-label>Center Name</mat-label>
          <mat-select formControlName="centreName">
            <mat-option *ngFor="let c of centres" [value]="c">{{c}}</mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field class="col-md-3" appearance="outline">
          <mat-label>Child Name</mat-label>
          <mat-select formControlName="childName">
            <mat-option *ngFor="let child of children" [value]="child">{{child}}</mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field class="col-md-3" appearance="outline">
          <mat-label>Date Range</mat-label>
          <input matInput [matDatepicker]="cgDate" formControlName="dateRange">
          <mat-datepicker-toggle matSuffix [for]="cgDate"></mat-datepicker-toggle>
          <mat-datepicker #cgDate></mat-datepicker>
        </mat-form-field>

        <mat-form-field class="col-md-3" appearance="outline">
          <mat-label>Session Type (All / Starred)</mat-label>
          <mat-select formControlName="sessionType">
            <mat-option *ngFor="let s of sessionTypes" [value]="s">{{s}}</mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field class="col-md-3" appearance="outline">
          <mat-label>Relation with Child</mat-label>
          <mat-select formControlName="relation">
            <mat-option *ngFor="let r of relations" [value]="r">{{r}}</mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field class="col-md-3" appearance="outline">
          <mat-label>Challenges</mat-label>
          <mat-select formControlName="challenges">
            <mat-option *ngFor="let c of challenges" [value]="c">{{c}}</mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field class="col-md-6" appearance="outline">
          <mat-label>Remarks by Counsellor</mat-label>
          <textarea matInput rows="3" formControlName="remarks"></textarea>
        </mat-form-field>

      </div>
    </mat-card>


    <!-- ░░ TEENS TABLE ░░ -->
    <mat-card class="p-3 mb-4" formGroupName="teen">
      <h4 class="mb-3">Teens</h4>

      <div class="row">

        <mat-form-field class="col-md-3" appearance="outline">
          <mat-label>Center Name</mat-label>
          <mat-select formControlName="centreName">
            <mat-option *ngFor="let c of centres" [value]="c">{{c}}</mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field class="col-md-3" appearance="outline">
          <mat-label>Child Name</mat-label>
          <mat-select formControlName="childName">
            <mat-option *ngFor="let child of children" [value]="child">{{child}}</mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field class="col-md-3" appearance="outline">
          <mat-label>Date Range</mat-label>
          <input matInput [matDatepicker]="tnDate" formControlName="dateRange">
          <mat-datepicker-toggle matSuffix [for]="tnDate"></mat-datepicker-toggle>
          <mat-datepicker #tnDate></mat-datepicker>
        </mat-form-field>

        <mat-form-field class="col-md-3" appearance="outline">
          <mat-label>Session Type</mat-label>
          <mat-select formControlName="sessionType">
            <mat-option *ngFor="let s of sessionTypes" [value]="s">{{s}}</mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field class="col-md-3" appearance="outline">
          <mat-label>Challenges</mat-label>
          <mat-select formControlName="challenges">
            <mat-option *ngFor="let c of challenges" [value]="c">{{c}}</mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field class="col-md-6" appearance="outline">
          <mat-label>Remarks</mat-label>
          <textarea matInput rows="3" formControlName="remarks"></textarea>
        </mat-form-field>

      </div>
    </mat-card>


    <!-- ░░ CHILD TABLE ░░ -->
    <mat-card class="p-3 mb-4" formGroupName="child">
      <h4 class="mb-3">Child</h4>

      <div class="row">

        <mat-form-field class="col-md-3" appearance="outline">
          <mat-label>Center Name</mat-label>
          <mat-select formControlName="centreName">
            <mat-option *ngFor="let c of centres" [value]="c">{{c}}</mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field class="col-md-3" appearance="outline">
          <mat-label>Child Name</mat-label>
          <mat-select formControlName="childName">
            <mat-option *ngFor="let child of children" [value]="child">{{child}}</mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field class="col-md-3" appearance="outline">
          <mat-label>Date Range</mat-label>
          <input matInput [matDatepicker]="chDate" formControlName="dateRange">
          <mat-datepicker-toggle matSuffix [for]="chDate"></mat-datepicker-toggle>
          <mat-datepicker #chDate></mat-datepicker>
        </mat-form-field>

        <mat-form-field class="col-md-3" appearance="outline">
          <mat-label>Session Type</mat-label>
          <mat-select formControlName="sessionType">
            <mat-option *ngFor="let s of sessionTypes" [value]="s">{{s}}</mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field class="col-md-3" appearance="outline">
          <mat-label>Challenges</mat-label>
          <mat-select formControlName="challenges">
            <mat-option *ngFor="let c of challenges" [value]="c">{{c}}</mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field class="col-md-6" appearance="outline">
          <mat-label>Remarks</mat-label>
          <textarea matInput rows="3" formControlName="remarks"></textarea>
        </mat-form-field>

      </div>
    </mat-card>

    <button mat-raised-button color="primary" (click)="submit()">Submit</button>

  </form>
</div>
